import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
  getFilteredData?: Function;
}

const ErrorDataTable: React.FC<TableComponentProps> = ({ data, searchVal, openModal,getFilteredData }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [original, setOriginal] = useState<any>([]);
  const [allRows, setAllRows] = useState<any>([]);

  const DefaultColumns = [ 
    { field: 'RFID Tag' },
    { field: 'Device ID' },
    { field: 'Error' },
    { field: 'Event Date' },
    { field: 'Truck Number' },
    { field: 'Service Provider Name' }
  ];


  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);

  var dateFilterParams = {
    comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('-');
      var cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2].includes(',') ? dateParts[2].split(',')[0] : dateParts[2].split(' ')[0])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: new Date().getFullYear()
  };

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];
      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = null;


        if (keys[i] === 'rfidtag') {
          obj = { headerName: 'RFID Tag', field: keys[i] }
        }
        else if (keys[i] === "hostname") {
          obj = { headerName: 'Device ID', field: keys[i] }
        }
        else if (keys[i] === "error") {
          obj = { field: keys[i], headerName: 'Error' }
        }
        else if (keys[i] === "eventdate") {
          obj = { headerName: 'Event Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
          }
        else if (keys[i] === "truckNo") {
          obj = { headerName: 'Truck Number', field: keys[i] }
        }
        else if (keys[i] === "serviceProviderName") {
          obj = { field: keys[i], headerName: 'Service Provider Name', width: 220  }
        }
        if (obj) {
              newKeys.push(obj);
            }
      }

      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
        setAllRows(newRows);
    }
    else {
      setRows([]);
      setOriginal([]);
      setColumns(DefaultColumns);
      setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true
  };
  
    // Downloading Only Filtered Data After Search
    useEffect(() => {
      if (getFilteredData)
        getFilteredData(rows);
    },[rows]);


  return (
    <Box className="ag-theme-material" sx={{ height: "85%", width: '100%' }}>
      <AgGridReact
        defaultColDef={defaultColDef}
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={200}
        suppressPreventDefaultOnMouseWheel={true}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default ErrorDataTable;
